import { Injectable } from '@angular/core';
import { getQueryParams } from '@pin-up-global/common';
import { Observable } from 'rxjs';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import {
  BotSticker,
  CreateStickerReq,
  GetBotStickersReq,
  RemoveStickerReq,
  UpdateStickerReq,
} from './stickers-settings.abstraction';

@Injectable({
  providedIn: 'root',
})
export class StickersSettingsApiService extends ApiService {
  isLoading$ = this._isLoading$;

  getBotStickers(params: GetBotStickersReq): Observable<ListResponse<BotSticker>> {
    return this._httpClient.get<ListResponse<BotSticker>>(
        `@api/settings/bots/stickers/`,
        { params: getQueryParams(params) },
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  createSticker(body: CreateStickerReq): Observable<BotSticker> {
    return this._httpClient.post<BotSticker>(
        '@api/settings/bots/stickers/',
        body,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  updateSticker(params: UpdateStickerReq): Observable<BotSticker> {
    const { id, ...body } = params;
    return this._httpClient.patch<BotSticker>(
        `@api/settings/bots/stickers/${ id }/`,
        body,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }

  removeSticker(params: RemoveStickerReq): Observable<void> {
    return this._httpClient.delete<void>(
        `@api/settings/bots/stickers/${ params.id }/`,
    ).pipe(
        manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
